export default "__VITE_ASSET__C4Q6EF3B__"